export default __webpack_public_path__ + "static/media/AmazingSpace.9458c988.png";